import { AddressDetails } from "../smart-components/smart-component-property";
import { IComponentLoader } from "../../interfaces/IComponentLoader";
import { ComponentAdapterParent } from "./component-adapter-parent";
import { SmartComponentPropertyDetails } from "../smart-components/smart-component-property-details";
import { SkillNameList } from "../../enum/enumSkillNameList";

/**
 * This class handle properties of dimmer
 */
export class ComponentAdaperDimmer extends ComponentAdapterParent implements IComponentLoader {
    private _turnOnOffCommand: AddressDetails = null;
    private _turnOnOffState: AddressDetails = null;
    private _brighnessCommand: AddressDetails = null;
    private _brighnessState: AddressDetails = null;
    private _faultState: AddressDetails = null;

    /**
     * Get the turn on/off command
     */
    get TurnOnOffCommand(): AddressDetails {
        return this._turnOnOffCommand;
    }

    /**
     * Get the turn on/off state
     */
    get TurnOnOffState(): AddressDetails {
        return this._turnOnOffState;
    }

    get BrighnessCommand(): AddressDetails {
        return this._brighnessCommand;
    }

    get BrighnessState(): AddressDetails {
        return this._brighnessState;
    }

    get FaultState(): AddressDetails {
        return this._faultState;
    }

    constructor() {
        super();
    }

    public fillProperty(listSmartComponentSkills: Array<SmartComponentPropertyDetails>): void {
        this._name = listSmartComponentSkills.find(titleSkill => titleSkill.titleSkill === SkillNameList.DIMMER_NAME)?.value || "";
        this._turnOnOffCommand = listSmartComponentSkills.find(titleSkill => titleSkill.titleSkill === SkillNameList.DIMMER_ON_OFF_COMMAND)?.address || null;
        this._turnOnOffState = listSmartComponentSkills.find(titleSkill => titleSkill.titleSkill === SkillNameList.DIMMER_ON_OFF_STATE)?.address || null;

        this._brighnessCommand = listSmartComponentSkills.find(titleSkill => titleSkill.titleSkill === SkillNameList.DIMMER_BRIGHTNESS_COMMAND)?.address || null;
        this._brighnessState = listSmartComponentSkills.find(titleSkill => titleSkill.titleSkill === SkillNameList.DIMMER_BRIGHTNESS_STATE)?.address || null;
        this._faultState = listSmartComponentSkills.find(titleSkill => titleSkill.titleSkill === SkillNameList.DIMMER_FAULT_STATE)?.address || null;

        this.fillMissingProperty();
        this.fillAddressState();
    }

    public fillMissingProperty(): void {
        //If the state is not set, set the state to the command
        if (this._turnOnOffState === null && this._turnOnOffCommand !== null) {
            this._turnOnOffState = this._turnOnOffCommand;
        }

        if (this._brighnessState === null && this._brighnessCommand !== null) {
            this._brighnessState = this._brighnessCommand;
        }
    }

    public fillAddressState(): void {
        if (this._turnOnOffState) {
            this._listSubscribeAddress.push(this._turnOnOffState);
        }

        if (this._brighnessState) {
            this._listSubscribeAddress.push(this._brighnessState);
        }

        if (this._faultState) {
            this._listSubscribeAddress.push(this._faultState);
        }
    }
}